
import axios from 'axios'
import EoButton from '../EoButton/EoButton.vue'
import EoIcon from '../EoIcon/EoIcon.vue'

export default {
  name: 'EoTiktok',
  components: { EoButton, EoIcon },
  props: {
    /**
     * Url of the post
     */
    url: {
      type: String,
      default: '',
    },
    /**
     * Are cookies enabled and allowed by the user?
     */
    cookiesAllowed: {
      type: Boolean,
      default: false,
    },
    /**
     * Fixed width
     */
    width: {
      type: [String, Number],
      default: 325,
    },
  },
  data() {
    return {
      embedHtml: null,
      scriptSrc: 'https://www.tiktok.com/embed.js',
    }
  },
  computed: {
    styles() {
      return {
        width: this.width && String(this.width)?.replace('px', '') + 'px',
      }
    },
  },
  mounted() {
    if (this.cookiesAllowed && this.url) {
      this.placeEmbed().then(() => {
        this.$script.load(this.scriptSrc)
      })
    }
  },
  updated() {
    if (this.cookiesAllowed && this.url) {
      this.placeEmbed().then(() => {
        this.$script.load(this.scriptSrc)
      })
    }
  },
  beforeDestroy() {
    this.$script.unload(this.scriptSrc)
  },
  methods: {
    async placeEmbed() {
      // Get oembed data
      const { data: { html } } = await axios.get(`https://www.tiktok.com/oembed?url=${encodeURI(this.url)}`)
      if (!html) return
      this.embedHtml = html
    },
  },
}
